<template>
  <BasePanelWithHeader collapsable headerText="Users">
    <template v-slot:content>
      <v-row>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.trackedBillUserForm.addTrackedBillUser()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add User Permissions
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="trackedBillUsers"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            v-if="
              currentUserPermissionID == 1 || item.TrackedBillPermissionID != 1
            "
            small
            @click="$refs.trackedBillUserForm.editTrackedBillUser(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit User Permissions
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            v-if="
              currentUserPermissionID == 1 || item.TrackedBillPermissionID != 1
            "
            small
            @click="$refs.trackedBillUserDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete User Permission
          </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="trackedBillUserDelete"
        :delete="deleteTrackedBillUser"
        @refresh="refresh"
      >
        Are you sure you want to delete this tracked bill user?
      </BaseDeleteConfirm>
      <TrackedBillUserDialogForm
        ref="trackedBillUserForm"
        :trackedBillID="trackedBillID"
        :currentUserPermissionID="currentUserPermissionID"
        @refresh="refresh"
      >
      </TrackedBillUserDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillUserDialogForm from '@components/form/add-edit/TrackedBillUserDialog'
export default {
  components: {
    TrackedBillUserDialogForm,
  },
  data: () => ({
    searchText: '',
  }),
  props: {
    trackedBillUsers: {
      type: Array,
      required: true,
    },
    trackedBillID: {
      type: Number,
      required: true,
    },
    currentUserPermissionID: {
      type: Number,
      required: true,
    },
  },
  created() {},
  computed: {
    ...get('trackedBillUser', ['loading']),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Tracked Bill ID',
          align: 'center',
          sortable: true,
          value: 'TrackedBillID',
          visible: false,
        },
        {
          text: 'User',
          align: 'center',
          sortable: true,
          value: 'User.Email',
          visible: true,
        },
        {
          text: 'Permission',
          align: 'center',
          sortable: true,
          value: 'TrackedBillPermission.Description',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: true,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('trackedBillUser', ['deleteTrackedBillUser']),
    refresh() {
      this.$emit('refreshUserPermissions')
    },
  },
}
</script>
<style>
</style>